import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-passes',
	templateUrl: './icon-passes.component.svg',
})
export class IconPassesComponent {}
